module.exports = __webpack_public_path__ + "static/media/hemmould.8d986e27.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/medicalDevices/hemmould.jpg
// module id = 231
// module chunks = 0